import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import {
  AbstractControl,
  NgControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { Globals } from '../global';
@Directive({
  selector: '[appRegexvalidation]',
})
export class RegexvalidationDirective {
  @Input() validationType: string = '';

  private patterns: { [key: string]: RegExp } = {
    numbersOnly: /^[0-9]*$/, // Numbers without decimal
    numbersWithMinus: /^\d*-?\d*(\.\d{0,2})?$/, //Number with Two decimal + minus
    numbersOnlyWithTwoDecimal: /^\d+(\.\d{0,2})?$/, // Numbers with Two decimal
    decimalNumbers: /^[0-9]*\.?[0-9]*$/, // Numbers with optional decimal
    allCharacters: /^[\w\W]*$/, // Accept everything
    customPattern: /^[a-zA-Z0-9_@]*$/, // Numbers, strings, _ and @
    noSpace: /^[^\s]*$/, // No spaces
    numberWithHyphen: /^[0-9-]*$/, // ✅ Numbers with optional hyphen
    onlyString: /^[A-Za-z]*$/,
    onlyStringWithSpace: /^[A-Za-z\s]*$/,
    email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{3,}$/,
    alphanumeric: /^[a-zA-Z0-9]*$/,
    alphanumericWithHyphenUnderscore: /^[a-zA-Z0-9_-]*$/,
  };

  constructor(private control: NgControl) { }

  @HostListener('input', ['$event'])
  onInput(event: InputEvent) {
    this.validateInput(event.target as HTMLInputElement);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault(); // Prevent default paste action

    const clipboardText = event.clipboardData?.getData('text') || '';
    const pattern = this.patterns[this.validationType];

    if (pattern && pattern.test(clipboardText)) {
      this.control.control?.setValue(clipboardText); // Set value if valid
    }

    // if (pattern && this.validationType !== 'email' && !pattern.test(clipboardText)) {
    //   const validValue = clipboardText.slice(0, -1);
    //   this.control.control?.setValue(validValue);
    // }
  }
  // @HostListener('blur', ['$event'])
  // onBlur(event: FocusEvent) {
  //   const inputElement = event.target as HTMLInputElement;
  //   const inputValue = inputElement.value.trim();
  //   const pattern = this.patterns[this.validationType];

  //   if (pattern && this.validationType === 'email' && !pattern.test(inputValue)) {
  //     this.control.control?.setValue(''); // Clear invalid email on blur
  //   }
  // }

  private validateInput(inputElement: HTMLInputElement) {
    const inputValue = inputElement.value;
    const pattern = this.patterns[this.validationType];

    if (
      pattern &&
      this.validationType !== 'email' &&
      !pattern.test(inputValue)
    ) {
      const validValue = inputValue.slice(0, -1);
      this.control.control?.setValue(validValue);
    }
  }
}

@Directive({
  selector: '[sanitizeInput]',
})
export class SanitizeInputDirective {
  @Input() enableSanitization: boolean = true; // Enable/Disable sanitization
  @Input() fieldType: 'text' | 'email' = 'text'; // Define field type
  constructor(private el: ElementRef, private control: NgControl) { }

  @HostListener('input', ['$event'])
  @HostListener('paste', ['$event'])
  onInput(event: Event) {
    if (!this.enableSanitization) return;

    const inputElement = event.target as HTMLInputElement;
    let sanitizedValue = inputElement.value;

    // Remove HTML tags
    sanitizedValue = sanitizedValue.replace(Globals.sanitizeHTML, '');

    if (this.fieldType === 'text') {
      // Text fields: Remove SQL keywords & dangerous characters
      sanitizedValue = sanitizedValue
        .replace(/[^a-zA-Z0-9_@\- .]/g, '') // ✅ Added dot (.) to allowed characters
        .replace(Globals.sanitizeSQL, ''); // Remove SQL keywords
    } else if (this.fieldType == 'email') {
      // Email fields: Allow @ and ., but remove SQL keywords
      sanitizedValue = sanitizedValue
        // .replace(/[^a-zA-Z0-9@._]/g, '') //Dont Allow `-`
        .replace(/[^a-zA-Z0-9@._-]/g, '') // Allow `-`
        .replace(Globals.sanitizeSQL, ''); // Remove SQL keywords
    }

    // Update form control only if sanitized
    if (inputElement.value !== sanitizedValue) {
      this.control.control?.setValue(sanitizedValue, { emitEvent: false });
    }
  }
}

export function noHtmlTagsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (typeof value === 'string' && /<\/?[a-z][\s\S]*>/i.test(value)) {
      return { noHtmlTags: true }; // Error if HTML tags found
    }
    return null; // Valid input
  };
}
